import { gql } from 'urql';

export const LIST_POLITICAS = gql`
  query ListPoliticas($empresaId: ID!, $modulo: PoliticaModulo, $activo: Boolean) {
    listPoliticas(empresaId: $empresaId, modulo: $modulo, activo: $activo) {
      id
      empresaId
      modulo
      evento
      cuentaIdDebe
      cuentaDebeCodigo
      cuentaDebeNombre
      cuentaIdHaber
      cuentaHaberCodigo
      cuentaHaberNombre
      centroId
      centroNombre
      activo
      createdAt
      updatedAt
    }
  }
`;

export const SET_POLITICA = gql`
  mutation SetPolitica($input: PoliticaInput!) {
    setPolitica(input: $input) {
      id
      modulo
      evento
      cuentaDebeCodigo
      cuentaDebeNombre
      cuentaHaberCodigo
      cuentaHaberNombre
      centroNombre
      activo
    }
  }
`;

export const ACTIVAR_POLITICA = gql`
  mutation ActivarPolitica($id: ID!, $activo: Boolean!) {
    activarPolitica(id: $id, activo: $activo) {
      id
      activo
    }
  }
`;

export const SIMULAR_POLITICA = gql`
  mutation SimularPolitica($empresaId: ID!, $modulo: PoliticaModulo!, $evento: String!, $importe: Float!, $moneda: AsientoLineaMoneda) {
    simularPolitica(empresaId: $empresaId, modulo: $modulo, evento: $evento, importe: $importe, moneda: $moneda) {
      asiento {
        detalle {
          cuentaCodigo
          cuentaNombre
          debe
          haber
        }
        totales {
          debe
          haber
          diferencia
        }
      }
    }
  }
`;

